import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {}
  
  showNotification(message, type = 'success') {
    this.removeExistingNotification()
    
    const notification = document.createElement('div')
    notification.className = `notification notification-${type}`
    notification.setAttribute('role', 'alert')
    notification.setAttribute('data-controller', 'notification')

    notification.innerHTML = `
      <div class="flex-shrink-0 bg-white/20 rounded-full p-1.5">
        ${this.getNotificationIcon(type)}
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm sm:text-base font-medium leading-relaxed">
          ${message}
        </p>
      </div>
      <button
        class="close-button close-button-${type}"
        data-action="notification#close"
        aria-label="Fechar notificação"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="close-icon"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    `
    
    const container = this.getNotificationContainer()
    container.appendChild(notification)
    
    setTimeout(() => {
      this.removeNotification(notification)
    }, 5000)
  }

  getNotificationIcon(type) {
    const icons = {
      success: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5 sm:h-6 sm:w-6">
          <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
        </svg>
      `,
      error: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5 sm:h-6 sm:w-6">
          <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
        </svg>
      `,
      warning: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5 sm:h-6 sm:w-6">
          <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
        </svg>
      `
    }

    return icons[type] || icons.success
  }

  getNotificationContainer() {
    let container = document.getElementById('notifications-container')
    
    if (!container) {
      container = document.createElement('div')
      container.id = 'notifications-container'
      container.className = 'fixed top-4 right-4 z-50 space-y-2'
      document.body.appendChild(container)
    }
    
    return container
  }

  removeExistingNotification() {
    const existing = document.querySelector('.notification')
    if (existing) {
      this.removeNotification(existing)
    }
  }

  removeNotification(notification) {
    if (notification && notification.parentNode) {
      // Animação de saída
      notification.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out'
      notification.style.opacity = '0'
      notification.style.transform = 'translateX(100%)'
      
      setTimeout(() => {
        notification.remove()
      }, 300)
    }
  }

  closeNotification(event) {
    const notification = event.target.closest('.notification')
    if (notification) {
      this.removeNotification(notification)
    }
  }
}